import { supabase } from '../lib/supabase';

const toCamelCase = (row) => ({
  id: row?.id,
  email: row?.email,
  fullName: row?.full_name,
  avatarUrl: row?.avatar_url,
  trialStartDate: row?.trial_start_date,
  subscriptionStatus: row?.subscription_status,
  createdAt: row?.created_at,
  updatedAt: row?.updated_at
});

export const userProfileService = {
  async getUserProfile(userId) {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.select('*')
        ?.eq('id', userId)
        ?.single();

      if (error) throw error;
      return { data: data ? toCamelCase(data) : null, error: null };
    } catch (error) {
      console.error('Error fetching user profile:', error);
      return { data: null, error };
    }
  },

  async getProfile(userId) {
    return this.getUserProfile(userId);
  },

  async updateUserAvatar(userId, avatarUrl) {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.update({ avatar_url: avatarUrl })
        ?.eq('id', userId)
        ?.select()
        ?.single();

      if (error) throw error;
      return { data: data ? toCamelCase(data) : null, error: null };
    } catch (error) {
      console.error('Error updating user avatar:', error);
      return { data: null, error };
    }
  },

  async updateProfile(userId, profileData) {
    try {
      const updates = {};
      
      if (profileData?.fullName !== undefined) updates.full_name = profileData?.fullName;
      if (profileData?.avatarUrl !== undefined) updates.avatar_url = profileData?.avatarUrl;
      if (profileData?.trialStartDate !== undefined) updates.trial_start_date = profileData?.trialStartDate;
      if (profileData?.subscriptionStatus !== undefined) updates.subscription_status = profileData?.subscriptionStatus;

      const { data, error } = await supabase?.from('user_profiles')?.update(updates)?.eq('id', userId)?.select()?.single();
      
      if (error) throw error;
      
      return { data: data ? toCamelCase(data) : null, error: null };
    } catch (error) {
      return { data: null, error };
    }
  },

  async cleanupTrialData(userId) {
    try {
      const { error } = await supabase?.rpc('cleanup_trial_user_data', {
        user_uuid: userId
      });
      
      if (error) throw error;
      
      return { error: null };
    } catch (error) {
      console.error('Error cleaning up trial data:', error);
      return { error };
    }
  },

  async getTrialInfo(userId) {
    try {
      const { data, error } = await supabase?.rpc('get_trial_info', {
        user_uuid: userId
      });
      
      if (error) throw error;
      
      // RPC returns array, get first result
      const trialInfo = data?.[0];
      
      return {
        data: trialInfo ? {
          isExpired: trialInfo?.is_expired,
          daysRemaining: trialInfo?.days_remaining,
          trialStart: trialInfo?.trial_start,
          subscriptionStatus: trialInfo?.subscription_status
        } : null,
        error: null
      };
    } catch (error) {
      console.error('Error fetching trial info:', error);
      return { data: null, error };
    }
  }
};